import translations from '@eworx/ckeditor5/translations/en.js'

translations.en.dictionary = {
    ...translations.en.dictionary,
    'WhatsAppOptInKeyword': 'Opt-In keyword',
    'WhatsAppOptOutKeyword': 'Opt-Out keyword',
    'WhatsAppProfileName': 'WhatsApp profile name',
}

export default translations;